import { rem } from "polished";
import { css } from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  ColorLabels,
  getInvertedColor,
} from "@/components/editor/utils/colors";

export const StyledHamburgerButton = withViewportStyle("div")<{
  isMenuOpen: boolean;
  disabled: boolean;
}>`
  height: ${rem(24)};
  width: ${rem(24)};
  display: none;
  align-items: center;
  align-self: center;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  margin: ${rem(4)};
  margin-left: ${rem(16)};

  ${(props) => props.$viewport.mobile`
    display: flex;
  `}

  .navigation-icon {
    ${({ isMenuOpen, theme }) => css`
      --icon-color: ${getInvertedColor(theme.colors[ColorLabels.BACKGROUND])};

      position: relative;
      height: ${rem(2)};
      width: 100%;
      background-color: ${isMenuOpen
        ? "transparent !important"
        : "var(--icon-color)"};
      display: inline-block;

      &::before,
      &::after {
        content: "";
        width: 100%;
        height: ${rem(2)};
        background-color: var(--icon-color);
        display: inline-block;
        position: absolute;
        left: 0;
        transition: all 0.2s;
      }

      &::before {
        top: ${isMenuOpen ? 0 : rem(-6)};
        transform: ${isMenuOpen ? "rotate(135deg)" : "rotate(0)"};
      }

      &::after {
        top: ${isMenuOpen ? 0 : rem(6)};
        transform: ${isMenuOpen ? "rotate(-135deg)" : "rotate(0)"};
      }
    `}
  }
`;
